'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var IS_BROWSER = typeof window !== 'undefined';
var IS_ANDROID = IS_BROWSER && /(android)/i.test(navigator.userAgent); // Bad, but needed

var IS_IOS = IS_BROWSER && /iPad|iPhone|iPod/.test(String(navigator.platform)); // Mock HTMLElement for Node

if (!IS_BROWSER && !global.HTMLElement) {
  global.HTMLElement = /*#__PURE__*/function () {
    function _class() {
      _classCallCheck(this, _class);
    }

    return _class;
  }();
}
/**
* closest
* @param {Element} element Element to traverse up from
* @param {String} selector A selector to search for matching parents or element itself
* @return {Element|null}  Element which is the closest ancestor matching selector
*/

var closest = function () {
  var proto = typeof window === 'undefined' ? {} : window.Element.prototype;
  var match = proto.matches || proto.msMatchesSelector || proto.webkitMatchesSelector;
  return proto.closest ? function (el, css) {
    return el.closest(css);
  } : function (el, css) {
    // IE jumps to shadow SVG DOM on clicking an SVG defined by <use>.
    // If so, jump back to <use> element and traverse real DOM
    if (el.correspondingUseElement) el = el.correspondingUseElement;

    for (; el; el = el.parentElement) {
      if (match.call(el, css)) return el;
    }

    return null;
  };
}();
/**
* dispatchEvent - with infinite loop prevention
* @param {Element} elem The target object
* @param {String} name The source object(s)
* @param {Object} detail Detail object (bubbles and cancelable is set to true)
* @return {Boolean} Whether the event was canceled
*/

function dispatchEvent(element, name) {
  var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var ignore = "prevent_recursive_dispatch_maximum_callstack".concat(name);
  var event;
  if (element[ignore]) return true; // We are already processing this event, so skip sending a new one
  else element[ignore] = true; // Add name to dispatching ignore

  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(name, {
      bubbles: true,
      cancelable: true,
      detail: detail
    });
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(name, true, true, detail);
  } // IE reports incorrect event.defaultPrevented
  // but correct return value on element.dispatchEvent


  var result = element.dispatchEvent(event);
  element[ignore] = null; // Remove name from dispatching ignore

  return result; // Follow W3C standard for return value
}
/**
 * toggleAttribute (Ponyfill for IE and Edge, fixes #299)
 * @link https://developer.mozilla.org/en-US/docs/Web/API/Element/toggleAttribute
 * @param {Element} el  Single DOM Element
 * @param {String} name The name of the attribute to be toggled
 * @param {Boolean} force Force attribute to be added or removed regardless of previous state
 */

function toggleAttribute(el, name) {
  var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !this.hasAttribute(name);
  if (!force === el.hasAttribute(name)) el[force ? 'setAttribute' : 'removeAttribute'](name, '');
  return force;
}
/**
* queryAll
* @param {String|NodeList|Array|Element} elements A CSS selector string, nodeList, element array, or single element
* @param {Element} context Node to look for elements within
* @return {Element[]} Array of elements
*/

function queryAll(elements) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

  if (elements) {
    if (elements.nodeType) return [elements];
    if (typeof elements === 'string') return [].slice.call(context.querySelectorAll(elements));
    if (elements.length) return [].slice.call(elements);
  }

  return [];
}

var FOCUSABLE = '[tabindex],a,button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled])';

var CoreDialog = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CoreDialog, _HTMLElement);

  function CoreDialog() {
    _classCallCheck(this, CoreDialog);

    return _possibleConstructorReturn(this, _getPrototypeOf(CoreDialog).apply(this, arguments));
  }

  _createClass(CoreDialog, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._focus = true; // Used to check if connectedCallback has run

      this._autoBackdrop = null;
      this.attributeChangedCallback(); // Ensure correct setup backdrop

      this.addEventListener('transitionend', this);
      document.addEventListener('keydown', this);
      document.addEventListener('click', this);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      reFocus(this._focus); // Try moving focus back to <button>

      if (this._autoBackdrop) this._autoBackdrop.parentNode.removeChild(this._autoBackdrop); // Remove generated backdrop element

      this._focus = this._autoBackdrop = null; // Garbage collection

      this.removeEventListener('transitionend', this);
      document.removeEventListener('keydown', this);
      document.removeEventListener('click', this);
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attr, prev, next) {
      var _this = this;

      if (this._focus) {
        // Only trigger after connectedCallback
        var prevBack = attr === 'backdrop' && getBackdrop(this, prev);
        var nextBack = this.backdrop; // Trigger repaint to fix IE11 from not closing dialog, and allow animating new backdrop

        this.className = this.className; // eslint-disable-line

        this.setAttribute('role', 'dialog');
        this.setAttribute('aria-modal', Boolean(nextBack));
        if (prevBack) prevBack.setAttribute('hidden', ''); // Hide previous backdrop

        if (nextBack) toggleAttribute(nextBack, 'hidden', this.hidden);

        if (this.hidden) {
          reFocus(this._focus);
        } else {
          var zIndex = window.getComputedStyle(this).getPropertyValue('z-index');

          if ((zIndex === 'auto' || zIndex === '0') && this.style.zIndex === '') {
            // Place this dialog over uppermost dialog if not controlled in CSS or JS
            var below = queryAll(this.nodeName).filter(function (el) {
              return el !== nextBack && !_this.contains(el) && isVisible(el);
            });
            zIndex = Math.min(Math.max.apply(Math, [1].concat(_toConsumableArray(below.map(getZIndex)))), 2000000000); // Avoid overflowing z-index. See techjunkie.com/maximum-z-index-value

            if (nextBack) nextBack.style.zIndex = zIndex + 1;
            this.style.zIndex = zIndex + 2;
          }

          this._focus = document.activeElement || document.body; // Remember last focused element

          setTimeout(function () {
            return setFocus(_this);
          }); // Move focus after paint (helps iOS and react portals)
        } // React might re-mount the DOM, so make sure prev and next did actually change


        if (attr === 'hidden' && next !== prev) dispatchEvent(this, 'dialog.toggle');
      }
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(event) {
      if (event.defaultPrevented) return;
      if (event.type === 'transitionend' && event.target === this && !this.hidden) setFocus(this); // Move focus after transition
      else if (event.type === 'click') {
          if (event.target === this.backdrop && !this.strict) return this.close(); // Click on backdrop

          var button = closest(event.target, 'button');
          var action = button && button.getAttribute('for');
          if (action === 'close' && closest(event.target, this.nodeName) === this) this.close();else if (action === this.id) {
            this.show();
          }
        } else if (event.type === 'keydown' && (event.keyCode === 9 || event.keyCode === 27) && !this.hidden) {
          var topDialog = queryAll("".concat(this.nodeName, ":not([hidden])")).sort(function (a, b) {
            return getZIndex(a) - getZIndex(b);
          }).pop();
          if (topDialog !== this) return; // event.target can be <body> when dialog has no focused element

          if (event.keyCode === 9) keepFocus(this, event); // TAB

          if (event.keyCode === 27 && !this.strict) {
            // ESC
            event.preventDefault(); // Prevent leaving maximized window in Safari

            this.close();
          }
        }
    }
  }, {
    key: "close",
    value: function close() {
      this.hidden = true;
    }
  }, {
    key: "show",
    value: function show() {
      this.hidden = false;
    }
  }, {
    key: "open",
    get: function get() {
      return !this.hidden;
    },
    set: function set(val) {
      this.hidden = !val;
    }
  }, {
    key: "strict",
    get: function get() {
      return this.hasAttribute('strict');
    },
    set: function set(val) {
      toggleAttribute(this, 'strict', val);
    } // Must set attribute for IE11

  }, {
    key: "hidden",
    get: function get() {
      return this.hasAttribute('hidden');
    },
    set: function set(val) {
      toggleAttribute(this, 'hidden', val);
    }
  }, {
    key: "backdrop",
    get: function get() {
      return getBackdrop(this, this.getAttribute('backdrop'));
    },
    set: function set(val) {
      this.setAttribute('backdrop', val || 'false');
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['hidden', 'backdrop'];
    }
  }]);

  return CoreDialog;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

function getBackdrop(el, attr) {
  var next = el.nextElementSibling;
  if (!el.parentNode || attr === 'false') return false;
  if (attr && attr !== 'true') return document.getElementById(attr) || false;
  if (next && next.nodeName === 'BACKDROP') return next;
  el._autoBackdrop = document.createElement('backdrop');
  return el.insertAdjacentElement('afterend', el._autoBackdrop);
}

function isVisible(el) {
  return el.clientWidth && el.clientHeight && window.getComputedStyle(el).getPropertyValue('visibility') !== 'hidden';
}

function getZIndex(element) {
  for (var el = element, zIndex = 1; el; el = el.offsetParent) {
    zIndex += Number(window.getComputedStyle(el).getPropertyValue('z-index')) || 0;
  }

  return zIndex;
}

function reFocus(el) {
  setTimeout(function () {
    // Move focus after paint (helps iOS and react portals)
    try {
      el.focus();
    } catch (err) {} // Element might have been removed

  });
}

function setFocus(el) {
  if (el.contains(document.activeElement) || !isVisible(el)) return; // Do not move if focus is already inside

  var focusable = queryAll('[autofocus]', el).concat(queryAll(FOCUSABLE, el)).filter(isVisible)[0];

  try {
    focusable.focus();
  } catch (err) {
    console.warn(el, 'is initialized without focusable elements. Please add [tabindex="-1"] the main element (for instance a <h1>)');
  }
}

function keepFocus(el, event) {
  var focusable = queryAll(FOCUSABLE, el).filter(isVisible);
  var onEdge = focusable[event.shiftKey ? 0 : focusable.length - 1]; // If focus moves us outside the dialog, we need to refocus to inside the dialog

  if (event.target === onEdge || !el.contains(event.target)) {
    event.preventDefault();
    focusable[event.shiftKey ? focusable.length - 1 : 0].focus();
  }
}

var version = "3.0.7";

/**
* closest
* @param {Element} el Element to traverse up from
* @param {String} css A selector to search for matching parents or element itself
* @return {Element|null}  Element which is the closest ancestor matching selector
*/

var closest$1 = function () {
  var proto = typeof window === 'undefined' ? {} : window.Element.prototype;
  var match = proto.matches || proto.msMatchesSelector || proto.webkitMatchesSelector;
  return proto.closest ? function (el, css) {
    return el.closest(css);
  } : function (el, css) {
    for (; el; el = el.parentElement) {
      if (match.call(el, css)) {
        return el;
      }
    }

    return null;
  };
}();
/**
* customElementToReact
* @param {Class|Function} elementClass A custom element definition.
* @param {Array} options Props and custom events
* @return {Object} A React component
*/


function customElementToReact(elementClass, options) {
  if (options === void 0) options = {};
  var name = elementClass.name || String(elementClass).match(/function ([^(]+)/)[1]; // String match for IE11

  var dashCase = name.replace(/.[A-Z]/g, function (ref) {
    var a = ref[0];
    var b = ref[1];
    return a + "-" + b;
  }); // NameName -> name-name

  var customProps = options.props || [];
  var customEvents = options.customEvents || [];
  var eventMap = customEvents.reduce(function (map, eventName) {
    map[eventName] = "on" + eventName.replace(/(^|\.)./g, function (m) {
      return m.slice(-1).toUpperCase();
    }); // input.filter => onInputFilter

    return map;
  }, {});
  var skipProps = customProps.concat('forwardRef', Object.keys(eventMap).map(function (onEventName) {
    return eventMap[onEventName];
  }));
  var tagName = (dashCase + "-" + (options.suffix || 'react')).replace(/\W+/g, '-').toLowerCase();
  return (/*@__PURE__*/function (superclass) {
      function anonymous(props) {
        var this$1 = this;
        superclass.call(this, props); // Register ref prop for accessing custom element https://reactjs.org/docs/refs-and-the-dom.html#callback-refs

        this.ref = function (el) {
          if (typeof this$1.props.forwardRef === 'function') {
            this$1.props.forwardRef(el);
          } else if (this$1.props.forwardRef) {
            this$1.props.forwardRef.current = el;
          }

          return this$1.el = el;
        }; // Register event handler on component for each custom event


        Object.keys(eventMap).forEach(function (eventName) {
          var onEventName = eventMap[eventName];

          this$1[eventName] = function (event) {
            if (this$1.props[onEventName] && closest$1(event.target, this$1.el.nodeName) === this$1.el) {
              this$1.props[onEventName](event);
            }
          };
        });
      }

      if (superclass) anonymous.__proto__ = superclass;
      anonymous.prototype = Object.create(superclass && superclass.prototype);
      anonymous.prototype.constructor = anonymous;

      anonymous.prototype.componentDidMount = function componentDidMount() {
        var this$1 = this; // Run connectedCallback() after React componentDidMount() to allow React hydration to run first

        if (!window.customElements.get(tagName)) {
          window.customElements.define(tagName, elementClass);
        } // Populate properties on custom element


        customProps.forEach(function (propName) {
          if (propName in this$1.props) {
            this$1.el[propName] = this$1.props[propName];
          }
        }); // Register events on custom element

        customEvents.forEach(function (eventName) {
          this$1.el.addEventListener(eventName, this$1[eventName]);
        });
      };

      anonymous.prototype.componentDidUpdate = function componentDidUpdate(prev) {
        var this$1 = this; // Sync prop changes to custom element

        customProps.forEach(function (propName) {
          if (prev[propName] !== this$1.props[propName]) {
            this$1.el[propName] = this$1.props[propName];
          }
        });
      };

      anonymous.prototype.componentWillUnmount = function componentWillUnmount() {
        var this$1 = this; // Remove event handlers on custom element on unmount

        customEvents.forEach(function (eventName) {
          this$1.el.removeEventListener(eventName, this$1[eventName]);
        });
      };

      anonymous.prototype.render = function render() {
        var this$1 = this; // Convert React props to CustomElement props https://github.com/facebook/react/issues/12810

        return React.createElement(tagName, Object.keys(this.props).reduce(function (thisProps, propName) {
          if (skipProps.indexOf(propName) === -1) {
            // Do not render customEvents and custom props as attributes
            if (propName === 'className') {
              thisProps["class"] = this$1.props[propName];
            } // Fixes className for custom elements
            else if (this$1.props[propName] === true) {
                thisProps[propName] = '';
              } // Fixes boolean attributes
              else if (this$1.props[propName] !== false) {
                  thisProps[propName] = this$1.props[propName];
                } // Pass only truthy, non-function props

          }

          return thisProps;
        }, {
          ref: this.ref
        }));
      };

      return anonymous;
    }(React.Component)
  );
}

var coreDialog = customElementToReact(CoreDialog, {
  customEvents: ['dialog.toggle'],
  props: ['backdrop'],
  suffix: version
});

module.exports = coreDialog;
